(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["client-portal"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.KashRequestBridge?.version === 2) return;
  const endpoint = 'https://kash-studio-manager.kashproductions4.chatgpt.site/api/public/requests';
  const deliveries = new WeakMap();
  const requestId = () => {
    if (crypto.randomUUID) return crypto.randomUUID();
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const value = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
    return `${value.slice(0, 8)}-${value.slice(8, 12)}-${value.slice(12, 16)}-${value.slice(16, 20)}-${value.slice(20)}`;
  };
  window.KashRequestBridge = {
    version: 2,
    async sendForm(form, payload) {
      const fingerprint = JSON.stringify(payload);
      let delivery = deliveries.get(form);
      if (!delivery || delivery.fingerprint !== fingerprint) {
        delivery = {fingerprint, id: requestId(), receipt: null};
        deliveries.set(form, delivery);
      }
      if (delivery.receipt) return delivery.receipt;
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(endpoint, {
          method: 'POST', mode: 'cors', credentials: 'omit',
          headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
          body: new URLSearchParams({...payload, id: delivery.id}).toString(),
          signal: controller.signal
        });
        const value = await response.json().catch(() => null);
        if (!response.ok || response.redirected || value?.ok !== true || value.id !== delivery.id) {
          throw new Error(value?.error || 'Your request has not been confirmed. Please try again.');
        }
        delivery.receipt = value;
        form.dataset.managerReceipt = value.id;
        return value;
      } finally {
        clearTimeout(timer);
      }
    },
    async prepareEmail(form) {
      if (form.dataset.hcaptchaBound || form.dataset.recaptchaBound || !window.Shopify?.captcha?.protect) return;
      await new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error('Your request is saved. Please try again to finish the email confirmation.')), 15000);
        window.Shopify.captcha.protect(form, () => {clearTimeout(timer); resolve();});
      });
    }
  };
})();
(() => {
  function mount(root) {
    if (!root || root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const controller = new AbortController();
    const signal = controller.signal;
    const $ = (selector) => root.querySelector(selector);
    const $$ = (selector) => [...root.querySelectorAll(selector)];
    const parse = (value, fallback) => { try { return JSON.parse(value); } catch { return fallback; } };
    const dictionary = parse(root.dataset.strings, {});
    const t = (key) => dictionary[key] || key;
    const escape = (value = '') => String(value ?? '').replace(/[&<>"']/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    const icon = (name) => root.querySelector(`template[data-icon="${name}"]`)?.innerHTML || '';
    const url = (value) => {
      if (!value || typeof value !== 'string') return '';
      try { const parsed = new URL(value, window.location.origin); return parsed.protocol === 'https:' ? parsed.href : ''; } catch { return ''; }
    };
    const picture = (value, width) => {
      const safe = url(value);
      if (!safe) return '';
      const parsed = new URL(safe);
      if (parsed.hostname === 'cdn.shopify.com' || parsed.hostname.endsWith('.shopify.com')) parsed.searchParams.set('width', String(width));
      return escape(parsed.href);
    };
    const payload = parse(root.dataset.portalData, {}) || {};
    const projects = Array.isArray(payload) ? payload : Array.isArray(payload.projects) ? payload.projects : [];
    const demo = root.dataset.demo === 'true';
    const signedIn = root.dataset.signedIn === 'true' || demo;
    const screen = $('[data-screen]');
    $('[data-toast]').hidden = true;
    const requestForm = $('#KashPortalRequest');
    const requestDialog = $('[data-request-dialog]');
    const mediaDialog = $('[data-media-dialog]');
    const paymentDialog = $('[data-payment-dialog]');
    const dialogHome = $('[data-form-home]');
    let view = 'overview', projectIndex = 0, filter = 'all', search = '', service = 'film';
    let requestType = 'new', requestItem = null, currentMedia = null, toastTimer, lastFocus;
    const status = (d) => String(d.status || '').toLowerCase();
    const isReady = (d) => /ready|review/.test(status(d)) || (!status(d) && Boolean(d.url));
    const isApproved = (d) => /approved|complete|delivered/.test(status(d));
    const project = () => projects[projectIndex];
    const deliverables = (p) => (Array.isArray(p?.deliverables) ? p.deliverables : []).map((d, i) => ({...d, _index:i}));
    const allDeliverables = () => projects.flatMap((p, i) => deliverables(p).map((d) => ({...d, _project:i})));
    const ref = (p) => String(p?.reference || p?.id || '');
    const imageOf = (d) => d?.thumbnail || d?.image || d?.cover_image || '';
    const friendlyDate = (value, opts = {month:'short',day:'numeric'}) => {
      if (!value) return t('to_confirm');
      if (!/^\d{4}-\d{2}-\d{2}/.test(String(value))) return String(value);
      const date = new Date(/^\d{4}-\d{2}-\d{2}$/.test(value) ? value + 'T12:00:00' : value);
      return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleDateString(root.dataset.locale || 'en-US', opts);
    };
    const button = (label, action, cls = '', attributes = '') => `<button type="button" class="kp-button ${cls}" data-action="${action}" ${attributes}>${label}</button>`;
    const goButton = (label, target, cls = '') => `<button type="button" class="kp-button ${cls}" data-go="${target}">${label}</button>`;
    function notify(message) { const toast = $('[data-toast]'); clearTimeout(toastTimer); toast.textContent = message; toast.hidden = false; toastTimer = setTimeout(() => {toast.hidden = true;}, 6000); }
    function openDialog(dialog) { lastFocus = document.activeElement; dialog.showModal(); }
    function closeDialog(dialog) { dialog.close(); }
    function header(title, subtitle, action = '') { return `<div class="kp-page-heading"><div><p class="kp-eyebrow">${escape(payload.client_name || root.dataset.clientName || t('workspace'))}</p><h1 tabindex="-1">${escape(title)}</h1><p>${escape(subtitle)}</p></div>${action}</div>`; }
    function selector() { return projects.length > 1 ? `<div class="kp-selector"><label for="kp-project-select">${escape(t('project'))}</label><select id="kp-project-select" data-project-select>${projects.map((p,i)=>`<option value="${i}" ${i===projectIndex?'selected':''}>${escape(p.title || t('untitled_project'))}</option>`).join('')}</select></div>` : ''; }
    function timeline(p) {
      if (!Array.isArray(p?.milestones) || !p.milestones.length) return `<p class="kp-terms">${escape(t('timeline_pending'))}</p>`;
      return `<ol class="kp-timeline">${p.milestones.map((m) => {
        const state = /^(complete|completed|done)$/.test(m.status) ? 'complete' : /^(current|active|in_progress)$/.test(m.status) ? 'current' : 'upcoming';
        return `<li class="is-${state}" ${state==='current'?'aria-current="step"':''}><span class="kp-milestone-icon" aria-hidden="true">${icon(state==='complete'?'check-circle':state==='current'?'radio-button':'circle')}</span><div><strong>${escape(m.label)}</strong><small>${escape(m.status_label || (state==='complete'?t('completed'):''))}${m.status_label || state==='complete' ? ' · ' : ''}${escape(friendlyDate(m.date))}</small></div></li>`;
      }).join('')}</ol>`;
    }
    function latest(p) {
      const updates = Array.isArray(p?.updates) ? p.updates : [];
      return updates[0] || (p?.latest_update ? {text:p.latest_update,date:p.updated_at || payload.last_updated} : null);
    }
    function update(p) { const item = latest(p); return `<div class="kp-update"><small>${escape(t('latest_update'))}</small><p>${escape(item?.text || item?.message || t('update_pending'))}</p>${item?.date ? `<time>${escape(friendlyDate(item.date))}</time>` : ''}</div>`; }
    function card(d, i) {
      const state = isApproved(d) ? t('approved') : isReady(d) ? t('ready_review') : d.status || t('in_progress');
      const meta = d.count ? `${d.count} ${t(d.type==='video'?'videos':'photos')}` : d.type || t('file');
      return `<article class="kp-deliverable"><button type="button" class="kp-thumb" data-action="deliverable" data-deliverable="${d._index ?? i}" data-project="${d._project ?? projectIndex}" aria-label="${escape(t('preview')+' '+d.title)}">${imageOf(d)?`<img src="${picture(imageOf(d),850)}" alt="${escape(d.title)}" loading="lazy" width="850" height="460">`:icon(d.type==='video'?'play':'folder-open')}</button><h3>${escape(d.title)}</h3><p>${escape(meta)} · ${escape(state)}</p></article>`;
    }
    function empty(title, copy, action = '') { return `<div class="kp-empty">${icon('folder-open')}<h2>${escape(title)}</h2><p>${escape(copy)}</p>${action}</div>`; }
    function overview() {
      const p = project();
      const date = demo ? new Date('2026-09-09T12:00:00') : new Date();
      let html = `<div class="kp-greeting"><div><p class="kp-eyebrow">${escape(payload.client_name || root.dataset.clientName || t('workspace'))}</p><h1 tabindex="-1">${escape(t('welcome'))}</h1><p class="kp-subtitle">${escape(t('welcome_intro'))}</p></div><time class="kp-date">${escape(date.toLocaleDateString(root.dataset.locale || 'en-US',{weekday:'long',month:'long',day:'numeric',year:'numeric'}))}</time></div>`;
      if (!p) return html + empty(t('no_projects'), t('no_projects_copy'), goButton(escape(t('start_new')) + icon('arrow-right'),'new','kp-button--primary'));
      html += selector();
      const ready = deliverables(p).filter(isReady);
      const summary = ready.length ? ready : deliverables(p).slice(0,3);
      const hero = imageOf(p);
      html += `<div class="kp-overview-grid"><article class="kp-hero ${hero?'':'kp-hero-empty'}">${hero?`<img src="${picture(hero,1800)}" alt="${escape(p.image_alt || p.title)}" width="1800" height="840" fetchpriority="high">`:icon('image')}${hero||url(p.preview_url)?`<button type="button" class="kp-icon-button kp-preview-button" data-action="project-preview" aria-label="${escape(t('preview_project'))}">${icon(url(p.preview_url)?'play':'arrows-out-simple')}</button>`:''}<div class="kp-hero-copy"><p class="kp-eyebrow">${escape(t('current_project'))}</p><h2>${escape(p.title || t('untitled_project'))}</h2><p>${escape(p.service || t('production_project'))}</p></div></article><section class="kp-status-summary" aria-label="${escape(t('project_status'))}"><div class="kp-section-heading"><h2>${escape(t('project_status'))}</h2><span class="kp-badge">${escape(p.status || t('in_progress'))}</span></div>${timeline(p)}${update(p)}<div class="kp-status-actions">${goButton(escape(t('view_project'))+icon('arrow-right'),'status','kp-button--primary')}${button(`<span class="kp-accent-icon">${icon('lightning')}</span>${escape(t('expedite_project'))}`,'go-expedite')}</div></section></div><section class="kp-deliverable-section"><div class="kp-section-heading"><div class="kp-heading-group"><h2>${escape(ready.length?t('ready_heading'):t('deliverables'))}</h2><p>${ready.length?escape(ready.length+' '+t('new_deliverables')):''}</p></div>${goButton(escape(ready.length?t('review_deliverables'):t('view_deliverables'))+icon('arrow-right'),'deliverables','kp-button--primary')}</div>${summary.length?`<div class="kp-deliverable-grid">${summary.slice(0,3).map(card).join('')}</div>`:empty(t('files_soon'),t('files_soon_copy'))}</section>`;
      return html;
    }
    function priority(p) {
      const available = url(p?.expedite_url) && p?.expedite_price && p?.expedite_due_date;
      return `<section class="kp-priority" id="kp-priority"><p class="kp-eyebrow">${escape(t('priority_delivery'))}</p><h3>${escape(t('need_sooner'))}</h3><p>${escape(p?.expedite_copy || t('expedite_intro'))}</p>${available?`<div class="kp-facts"><div><span>${escape(t('earlier_delivery'))}</span><strong>${escape(friendlyDate(p.expedite_due_date))}</strong></div><div><span>${escape(t('expedite_fee'))}</span><strong>${escape(p.expedite_price)}</strong></div></div>${button(escape(t('review_upgrade'))+icon('arrow-right'),'payment','kp-button--primary')}`:button(escape(t('request_expedite'))+icon('arrow-right'),'request-expedite')}<p class="kp-form-note">${escape(t('priority_note'))}</p></section>`;
    }
    function projectStatus() {
      const p=project();
      if(!p) return header(t('project_status'),t('status_intro'))+empty(t('no_projects'),t('no_projects_copy'),goButton(escape(t('start_new')),'new','kp-button--primary'));
      const updates=Array.isArray(p.updates)?p.updates:latest(p)?[latest(p)]:[];
      return header(p.title || t('project_status'),p.service || t('status_intro'),goButton(escape(t('view_deliverables'))+icon('arrow-right'),'deliverables'))+selector()+`<div class="kp-detail-layout"><section>${imageOf(p)?`<img class="kp-detail-image" src="${picture(imageOf(p),1300)}" alt="${escape(p.title)}" width="1300" height="520">`:''}<div class="kp-facts"><div><span>${escape(t('current_stage'))}</span><strong>${escape(p.current_stage || p.status || t('in_progress'))}</strong></div><div><span>${escape(t('target_delivery'))}</span><strong>${escape(friendlyDate(p.due_date))}</strong></div><div><span>${escape(t('next_milestone'))}</span><strong>${escape(p.next_milestone || t('to_confirm'))}</strong></div></div><div class="kp-section-heading"><h2>${escape(t('project_updates'))}</h2>${button(escape(t('ask_question')),'question')}</div>${updates.length?`<ul class="kp-updates">${updates.map(u=>`<li>${u.date?`<time>${escape(friendlyDate(u.date))}</time>`:''}<p>${escape(u.text || u.message)}</p></li>`).join('')}</ul>`:`<p class="kp-terms">${escape(t('update_pending'))}</p>`}${ref(p)?`<p class="kp-form-note">${escape(t('reference'))} ${escape(ref(p))}</p>`:''}</section><aside><div class="kp-section-heading"><h2>${escape(t('timeline'))}</h2><span class="kp-badge">${escape(p.status || t('in_progress'))}</span></div>${timeline(p)}${priority(p)}</aside></div>`;
    }
    function library() {
      const html = header(t('deliverables'),t('deliverables_intro'))+`<div class="kp-toolbar"><div class="kp-filters" aria-label="${escape(t('filter_deliverables'))}">${['all','review','approved'].map(f=>`<button type="button" class="kp-filter" data-filter="${f}" aria-pressed="${filter===f}">${escape(t(f==='review'?'ready_review':f))}</button>`).join('')}</div><div class="kp-search">${icon('magnifying-glass')}<label class="visually-hidden" for="kp-search">${escape(t('search_deliverables'))}</label><input id="kp-search" type="search" value="${escape(search)}" data-search placeholder="${escape(t('search_deliverables'))}"></div></div><div data-library-results></div>`;
      return html;
    }
    function refreshLibrary() {
      const list=allDeliverables().filter(d=>(filter==='all'||filter==='review'&&isReady(d)||filter==='approved'&&isApproved(d))&&String(d.title||'').toLowerCase().includes(search.toLowerCase()));
      const el=$('[data-library-results]');
      if(el)el.innerHTML=list.length?`<div class="kp-deliverable-grid kp-library-grid">${list.map(card).join('')}</div>`:empty(t('no_results'),t('no_results_copy'));
    }
    function newProject() {
      return header(t('start_new'),t('new_intro'))+`<div class="kp-new-layout"><div><div class="kp-service-options" role="group" aria-label="${escape(t('choose_service'))}">${['film','photography','campaign','other'].map(s=>`<button class="kp-service" type="button" data-service="${s}" aria-pressed="${service===s}"><strong>${escape(t('service_'+s))}</strong><span>${escape(t('service_'+s+'_copy'))}</span></button>`).join('')}</div><div data-new-form-slot></div></div><aside class="kp-new-aside"><p class="kp-eyebrow">${escape(t('next_steps'))}</p><h2>${escape(t('idea_to_production'))}</h2><ol><li>${escape(t('next_step_1'))}</li><li>${escape(t('next_step_2'))}</li><li>${escape(t('next_step_3'))}</li></ol><p class="kp-form-note">${escape(t('new_note'))}</p></aside></div>`;
    }
    function moveForm(target, type) {
      if (!requestForm || !target) return;
      requestType=type;
      target.appendChild(requestForm);
      requestForm.hidden=false;
      const isNew=type==='new';
      requestForm.querySelectorAll('[data-new-only]').forEach(el=>{el.hidden=!isNew;el.querySelectorAll('input,select').forEach(input=>{input.disabled=!isNew; if(input.dataset.required==='true') input.required=isNew;});});
      const textarea=requestForm.querySelector('[data-brief]');
      textarea.required=type!=='approval';
      textarea.placeholder=t(isNew?'brief_placeholder':type==='approval'?'approval_placeholder':'message_placeholder');
      requestForm.querySelector('[data-brief-label]').textContent=t(isNew?'project_brief':type==='approval'?'optional_note':'your_message');
      requestForm.querySelector('[data-submit-label]').textContent=t(type==='new'?'send_brief':type==='approval'?'send_approval':'send_request');
      requestForm.querySelector('[data-form-description]').textContent=t(demo?'demo_form_note':'form_note');
      requestForm.querySelector('[data-service-value]').value=t('service_'+service);
    }
    function openRequest(type, item = null) {
      requestItem=item;
      const labels={expedite:'request_expedite',revision:'request_changes',approval:'send_approval',question:'ask_question'};
      const intros={expedite:'expedite_request_copy',revision:'revision_copy',approval:'approval_copy',question:'question_copy'};
      $('[data-request-title]').textContent=t(labels[type]||'send_request');
      $('[data-request-intro]').textContent=t(intros[type]||'question_copy');
      requestForm.querySelector('[data-brief]').value='';
      moveForm(dialogHome,type);
      openDialog(requestDialog);
    }
    function render(next, push = true, focus = true) {
      if (!signedIn) return;
      if(requestForm?.parentElement)dialogHome.appendChild(requestForm);
      view=['overview','status','deliverables','new','signin'].includes(next)?next:'overview';
      if(view==='signin'&&!demo)view='overview';
      $$('[data-nav]').forEach(b=>{if(b.dataset.go===view)b.setAttribute('aria-current','page');else b.removeAttribute('aria-current');});
      $('[data-account-menu]')?.setAttribute('hidden','');
      $('[data-account-toggle]')?.setAttribute('aria-expanded','false');
      screen.classList.remove('kp-screen');
      screen.innerHTML=view==='overview'?overview():view==='status'?projectStatus():view==='deliverables'?library():view==='new'?newProject():$('[data-signin-template]').innerHTML;
      screen.classList.add('kp-screen');
      if(view==='new')moveForm($('[data-new-form-slot]'),'new');
      if(view==='deliverables')refreshLibrary();
      if(push)history.pushState({kp:true},'',`#${view}`);
      if(focus){screen.querySelector('h1')?.focus({preventScroll:true});window.scrollTo({top:0,behavior:'instant'});}
    }
    function showMedia(d, p, isProject=false) {
      currentMedia={d,p,isProject};
      const video=url(isProject?p.preview_url:d.preview_url || (d.type==='video'?d.url:''));
      const image=url(imageOf(d) || (isProject?imageOf(p):''));
      const playable=video&&/\.(mp4|webm|mov)(?:[?#]|$)/i.test(video);
      const media=playable?`<video class="kp-dialog-media" controls playsinline preload="metadata" ${image?`poster="${escape(image)}"`:''}><source src="${escape(video)}"></video>`:image?`<img class="kp-dialog-media" src="${picture(image,2000)}" alt="${escape(d.title || p.title)}" width="1800" height="840">`:`<div class="kp-empty">${icon('folder-open')}<p>${escape(t('external_preview'))}</p></div>`;
      const external=url(d.review_url || d.url || (isProject?p.preview_url:''));
      $('[data-media-content]').innerHTML=media+`<div class="kp-dialog-body"><p class="kp-eyebrow">${escape(p.title)}</p><h2 id="kp-media-title">${escape(d.title || p.title)}</h2><p>${escape(d.description || (isProject?p.service:t('review_intro')) || '')}</p><div class="kp-dialog-actions"><div>${!isProject&&!isApproved(d)?`${button(escape(t('send_approval')),'approve','kp-button--primary')}${button(escape(t('request_changes')),'revision')}`:''}</div><div>${url(d.download_url)?`<a class="kp-button" href="${escape(url(d.download_url))}" target="_blank" rel="noopener noreferrer">${icon('download-simple')}${escape(t('download'))}</a>`:''}${external?`<a class="kp-button" href="${escape(external)}" target="_blank" rel="noopener noreferrer">${escape(t(isProject?'open_preview':'open_files'))}${icon('arrow-up-right')}</a>`:''}</div></div>${demo?`<p class="kp-form-note">${escape(t('demo_media_note'))}</p>`:''}${!isProject&&isApproved(d)?`<p class="kp-form-note">${escape(t('already_approved'))}</p>`:''}</div>`;
      openDialog(mediaDialog);
    }
    function showPayment() {
      const p=project();
      if(!(url(p?.expedite_url)&&p?.expedite_price&&p?.expedite_due_date)){openRequest('expedite');return;}
      $('[data-payment-content]').innerHTML=`<div class="kp-dialog-body"><p class="kp-eyebrow">${escape(t('priority_delivery'))}</p><h2 id="kp-payment-title">${escape(t('review_upgrade'))}</h2><p>${escape(p.title)}</p><div class="kp-facts"><div><span>${escape(t('current_delivery'))}</span><strong>${escape(friendlyDate(p.due_date))}</strong></div><div><span>${escape(t('earlier_delivery'))}</span><strong>${escape(friendlyDate(p.expedite_due_date))}</strong></div><div><span>${escape(t('expedite_fee'))}</span><strong>${escape(p.expedite_price)}</strong></div></div><p class="kp-terms">${escape(t('payment_note'))}</p><a class="kp-button kp-button--primary" href="${escape(url(p.expedite_url))}">${escape(t('continue_payment'))}${icon('arrow-right')}</a></div>`;
      openDialog(paymentDialog);
    }
    root.addEventListener('click',(event)=>{
      const go=event.target.closest('[data-go]');if(go){render(go.dataset.go);return;}
      const close=event.target.closest('[data-close]');if(close){closeDialog(close.closest('dialog'));return;}
      const filterButton=event.target.closest('[data-filter]');if(filterButton){filter=filterButton.dataset.filter;$$('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===filterButton)));refreshLibrary();return;}
      const serviceButton=event.target.closest('[data-service]');if(serviceButton){service=serviceButton.dataset.service;$$('[data-service]').forEach(b=>b.setAttribute('aria-pressed',String(b===serviceButton)));requestForm.querySelector('[data-service-value]').value=t('service_'+service);return;}
      const action=event.target.closest('[data-action]');if(!action)return;
      switch(action.dataset.action){
        case 'account': {const menu=$('[data-account-menu]');menu.hidden=!menu.hidden;action.setAttribute('aria-expanded',String(!menu.hidden));break;}
        case 'go-expedite': render('status');$('#kp-priority')?.scrollIntoView({block:'center',behavior:'smooth'});break;
        case 'request-expedite':openRequest('expedite');break;
        case 'question':openRequest('question');break;
        case 'payment':showPayment();break;
        case 'project-preview':showMedia({title:project().title,image:imageOf(project())},project(),true);break;
        case 'deliverable':{const p=projects[Number(action.dataset.project)];const d=deliverables(p)[Number(action.dataset.deliverable)];if(d&&p){projectIndex=Number(action.dataset.project);showMedia(d,p);}break;}
        case 'approve':case 'revision':{const data=currentMedia;closeDialog(mediaDialog);if(data)openRequest(action.dataset.action==='approve'?'approval':'revision',data.d);break;}
      }
    },{signal});
    root.addEventListener('input',(event)=>{if(event.target.matches('[data-search]')){search=event.target.value;refreshLibrary();}},{signal});
    root.addEventListener('change',(event)=>{if(event.target.matches('[data-project-select]')){projectIndex=Number(event.target.value)||0;render(view,false,false);}},{signal});
    document.addEventListener('click',(event)=>{const menu=$('[data-account-menu]');if(menu&&!menu.hidden&&!event.target.closest('.kp-account')){menu.hidden=true;$('[data-account-toggle]').setAttribute('aria-expanded','false');}},{signal});
    root.addEventListener('keydown',(event)=>{if(event.key==='Escape'){const menu=$('[data-account-menu]');if(menu&&!menu.hidden){menu.hidden=true;$('[data-account-toggle]').setAttribute('aria-expanded','false');$('[data-account-toggle]').focus();}}},{signal});
    $$('dialog').forEach(dialog=>{
      dialog.addEventListener('click',(event)=>{if(event.target===dialog){const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();}},{signal});
      dialog.addEventListener('close',()=>{dialog.querySelectorAll('video').forEach(v=>v.pause());if(lastFocus?.isConnected)lastFocus.focus({preventScroll:true});},{signal});
    });
    let submitting = false, emailReady = false;
    if(requestForm){
      const dateInput=requestForm.querySelector('[data-date-input]');
      if(dateInput){const today=new Date();dateInput.min=[today.getFullYear(),String(today.getMonth()+1).padStart(2,'0'),String(today.getDate()).padStart(2,'0')].join('-');}
      requestForm.addEventListener('submit',async(event)=>{
        if(emailReady)return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if(submitting)return;
        if(!requestForm.reportValidity())return;
        const title=requestForm.querySelector('[data-project-title]')?.value || '';
        const lines=[t('request_type')+': '+t(requestType==='new'?'start_new':requestType==='approval'?'send_approval':requestType==='revision'?'request_changes':requestType==='expedite'?'request_expedite':'ask_question')];
        if(requestType==='new')lines.push(t('project_title')+': '+title,t('service')+': '+t('service_'+service));
        else {lines.push(t('project')+': '+(project()?.title||''),t('reference')+': '+ref(project()));if(requestItem)lines.push(t('deliverable')+': '+requestItem.title);}
        lines.push('',requestForm.querySelector('[data-brief]').value);
        requestForm.querySelector('[data-message-body]').value=lines.join('\n');
        if(demo){if(requestDialog.open)closeDialog(requestDialog);notify(t('demo_submitted'));return;}
        submitting=true;
        const submit=requestForm.querySelector('[type=submit]');submit.disabled=true;requestForm.querySelector('[data-submit-label]').textContent=t('sending');
        try{
          const selectedProject=requestType==='new'?null:project();
          await window.KashRequestBridge.sendForm(requestForm,{
            kind:requestType,title,
            message:requestForm.querySelector('[data-brief]').value,
            name:requestForm.querySelector('#kp-name').value,
            email:requestForm.querySelector('#kp-email').value,
            phone:'',service:requestType==='new'?t('service_'+service):(selectedProject?.service||''),
            idealDate:requestType==='new'?(requestForm.querySelector('#kp-deadline')?.value||''):'',
            budget:requestType==='new'?(requestForm.querySelector('#kp-budget')?.value||''):'',
            projectReference:selectedProject?ref(selectedProject):'',deliverableTitle:requestItem?.title||'',
            source:'Client portal',website:''
          });
          await window.KashRequestBridge.prepareEmail(requestForm);
          submitting=false;
          submit.disabled=false;
          emailReady=true;
          try{requestForm.requestSubmit(submit);}finally{emailReady=false;requestForm.querySelector('[data-submit-label]').textContent=t(requestType==='new'?'send_brief':requestType==='approval'?'send_approval':'send_request');}
        }catch(error){
          submitting=false;
          submit.disabled=false;
          requestForm.querySelector('[data-submit-label]').textContent=t(requestType==='new'?'send_brief':requestType==='approval'?'send_approval':'send_request');
          notify(error?.message||t('request_error'));
        }
      },{signal,capture:true});
    }
    window.addEventListener('pageshow',()=>{submitting=false;if(requestForm){const submit=requestForm.querySelector('[type=submit]');submit.disabled=false;requestForm.querySelector('[data-submit-label]').textContent=t(requestType==='new'?'send_brief':requestType==='approval'?'send_approval':'send_request');}},{signal});
    window.addEventListener('popstate',()=>render(location.hash.slice(1)||'overview',false),{signal});
    document.addEventListener('shopify:section:unload',(event)=>{if(event.target.contains(root)){controller.abort();clearTimeout(toastTimer);}},{signal});
    if(signedIn)render(location.hash.slice(1)||'overview',false,false);
    $$('[data-server-result]').forEach(result => { root.querySelector('.kp-shell').prepend(result); });
  }
  mount(document.getElementById('KashPortal'));
  document.addEventListener('shopify:section:load',()=>mount(document.getElementById('KashPortal')));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.KashRequestBridge?.version === 2) return;
  const endpoint = 'https://kash-studio-manager.kashproductions4.chatgpt.site/api/public/requests';
  const deliveries = new WeakMap();
  const requestId = () => {
    if (crypto.randomUUID) return crypto.randomUUID();
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const value = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
    return `${value.slice(0, 8)}-${value.slice(8, 12)}-${value.slice(12, 16)}-${value.slice(16, 20)}-${value.slice(20)}`;
  };
  window.KashRequestBridge = {
    version: 2,
    async sendForm(form, payload) {
      const fingerprint = JSON.stringify(payload);
      let delivery = deliveries.get(form);
      if (!delivery || delivery.fingerprint !== fingerprint) {
        delivery = {fingerprint, id: requestId(), receipt: null};
        deliveries.set(form, delivery);
      }
      if (delivery.receipt) return delivery.receipt;
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(endpoint, {
          method: 'POST', mode: 'cors', credentials: 'omit',
          headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
          body: new URLSearchParams({...payload, id: delivery.id}).toString(),
          signal: controller.signal
        });
        const value = await response.json().catch(() => null);
        if (!response.ok || response.redirected || value?.ok !== true || value.id !== delivery.id) {
          throw new Error(value?.error || 'Your request has not been confirmed. Please try again.');
        }
        delivery.receipt = value;
        form.dataset.managerReceipt = value.id;
        return value;
      } finally {
        clearTimeout(timer);
      }
    },
    async prepareEmail(form) {
      if (form.dataset.hcaptchaBound || form.dataset.recaptchaBound || !window.Shopify?.captcha?.protect) return;
      await new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error('Your request is saved. Please try again to finish the email confirmation.')), 15000);
        window.Shopify.captcha.protect(form, () => {clearTimeout(timer); resolve();});
      });
    }
  };
})();
(() => {
  const mount = root => {
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';
    const form = root.querySelector('#KashContactForm');
    if (!form) return;
    const buttons = Array.from(root.querySelectorAll('[data-kc-service]'));
    const serviceInput = root.querySelector('[data-kc-service-value]');
    let serviceLabel = buttons.find(button => button.getAttribute('aria-pressed') === 'true')?.dataset.label || '';
    const errorBox = root.querySelector('[data-kc-error]');
    const dateInput = root.querySelector('#KashContact-date');
    if (dateInput) {
      const today = new Date();
      dateInput.min = [today.getFullYear(), String(today.getMonth() + 1).padStart(2, '0'), String(today.getDate()).padStart(2, '0')].join('-');
    }
    buttons.forEach(button => button.addEventListener('click', () => {
      buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      serviceLabel = button.dataset.label;
      serviceInput.value = serviceLabel;
      serviceInput.setAttribute('value', serviceLabel);
    }));
    let submitting = false, emailReady = false;
    form.addEventListener('submit', async event => {
      if (emailReady) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (submitting) return;
      if (!form.reportValidity()) return;
      const submit = form.querySelector('[type=submit]');
      const label = form.querySelector('[data-kc-submit]');
      const original = label.textContent;
      submitting = true;
      submit.disabled = true;
      label.textContent = root.dataset.sendingCopy;
      errorBox.hidden = true;
      try {
        await window.KashRequestBridge.sendForm(form, {
          kind: 'new',
          title: form.querySelector('#KashContact-title').value,
          message: form.querySelector('#KashContact-body').value,
          name: form.querySelector('#KashContact-name').value,
          email: form.querySelector('#KashContact-email').value,
          phone: form.querySelector('#KashContact-phone').value,
          service: serviceLabel,
          idealDate: dateInput.value,
          budget: form.querySelector('#KashContact-budget').value,
          projectReference: '', deliverableTitle: '', source: 'Contact page',
          website: form.querySelector('#KashContact-website').value
        });
        await window.KashRequestBridge.prepareEmail(form);
        submitting = false;
        submit.disabled = false;
        emailReady = true;
        try { form.requestSubmit(submit); } finally { emailReady = false; label.textContent = original; }
      } catch (error) {
        submitting = false;
        submit.disabled = false;
        label.textContent = original;
        errorBox.textContent = error?.message || root.dataset.errorCopy;
        errorBox.hidden = false;
        errorBox.focus();
      }
    }, {capture: true});
    window.addEventListener('pageshow', () => {
      submitting = false;
      form.querySelector('[type=submit]').disabled = false;
    });
  };
  document.querySelectorAll('.kc-section').forEach(mount);
  document.addEventListener('shopify:section:load', event => mount(event.target.matches?.('[id^="KashContact-"]') ? event.target : event.target.querySelector('[id^="KashContact-"]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = window.scrollY || 0;
      this.headerBounds = this.header.getBoundingClientRect();
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kash-home-desktop"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '.kash-home-hero__video';
  const screenQuery = window.matchMedia('(min-width: 769px)');

  const attemptPlayback = (video) => {
    if (document.hidden || !screenQuery.matches) { video.pause(); return; }
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;

    const playback = video.play();
    if (playback && typeof playback.catch === 'function') {
      playback.catch(() => {});
    }
  };

  const playHeroVideos = () => {
    document.querySelectorAll(selector).forEach((video) => {
      attemptPlayback(video);

      if (!video.dataset.kashAutoplayRetryBound) {
        video.dataset.kashAutoplayRetryBound = 'true';
        video.addEventListener('loadeddata', () => attemptPlayback(video), { once: true });
        video.addEventListener('canplay', () => attemptPlayback(video), { once: true });
      }
    });
  };

  if (!window.__kashDesktopHeroAutoplayBound) {
    window.__kashDesktopHeroAutoplayBound = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', playHeroVideos, { once: true });
    } else {
      playHeroVideos();
    }

    window.addEventListener('load', playHeroVideos, { once: true });
    window.addEventListener('pageshow', playHeroVideos);
    window.addEventListener('pagehide', () => document.querySelectorAll(selector).forEach(video => video.pause()));
    screenQuery.addEventListener('change', playHeroVideos);
    document.addEventListener('visibilitychange', () => {
      playHeroVideos();
    });
    document.addEventListener('shopify:section:load', playHeroVideos);
    document.addEventListener('shopify:section:select', playHeroVideos);
  } else {
    playHeroVideos();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kash-home-mobile"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-kash-mobile-video]';
  const screenQuery = window.matchMedia('(max-width: 768px)');

  const startVideo = (video) => {
    if (!(video instanceof HTMLVideoElement)) return;
    if (document.hidden || !screenQuery.matches) { video.pause(); return; }

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    const playback = video.play();
    if (playback && typeof playback.catch === 'function') {
      playback.catch(() => {});
    }
  };

  const startAllVideos = () => {
    document.querySelectorAll(selector).forEach((video) => {
      if (!video.dataset.kashAutoplayBound) {
        video.dataset.kashAutoplayBound = 'true';
        video.addEventListener('loadedmetadata', () => startVideo(video));
        video.addEventListener('canplay', () => startVideo(video));
      }

      startVideo(video);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startAllVideos, { once: true });
  } else {
    startAllVideos();
  }

  window.addEventListener('pageshow', startAllVideos);
  window.addEventListener('pagehide', () => document.querySelectorAll(selector).forEach(video => video.pause()));
  screenQuery.addEventListener('change', startAllVideos);
  document.addEventListener('visibilitychange', () => {
    startAllVideos();
  });
  document.addEventListener('shopify:section:load', startAllVideos);

  if (!window.__kashMobileAutoplayFallbackBound) {
    window.__kashMobileAutoplayFallbackBound = true;
    document.addEventListener('touchstart', startAllVideos, { once: true, passive: true });
    document.addEventListener('pointerdown', startAllVideos, { once: true, passive: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kash-submenu-timing"]) return;
  try {
    
(() => {
  if (window.__kashSubmenuZeroFlashBound) return;
  window.__kashSubmenuZeroFlashBound = true;

  const selector = '.section-header header-drawer .menu-drawer__navigation summary.menu-drawer__menu-item';

  document.addEventListener(
    'click',
    (event) => {
      const summary = event.target.closest(selector);
      if (!summary) return;

      const details = summary.parentElement;
      const submenu = summary.nextElementSibling;

      if (!details || details.tagName !== 'DETAILS') return;
      if (!submenu?.classList.contains('menu-drawer__submenu')) return;
      if (details.hasAttribute('open')) return;

      /*
       * Stop Dawn's delayed submenu opener. We apply the entire open state in this same
       * event task, before Safari can paint an intermediate [open]-only frame.
       */
      event.preventDefault();
      event.stopPropagation();

      const parentMenu = details.closest('.menu-drawer__menu.has-submenu');
      const branchItem = details.parentElement;

      parentMenu?.classList.add('kash-submenu-switching');

      if (branchItem) {
        branchItem.style.setProperty('transition', 'none', 'important');
        branchItem.style.setProperty('-webkit-transition', 'none', 'important');
        branchItem.style.setProperty('transform', 'none', 'important');
        branchItem.style.setProperty('-webkit-transform', 'none', 'important');
      }

      details.setAttribute('open', '');
      details.classList.add('menu-opening');
      summary.setAttribute('aria-expanded', 'true');
      parentMenu?.classList.add('submenu-open');
      parentMenu?.classList.remove('kash-submenu-switching');

      const closeButton = submenu.querySelector(':scope > .menu-drawer__inner-submenu > .menu-drawer__close-button');
      if (typeof trapFocus === 'function' && closeButton) {
        requestAnimationFrame(() => {
          try {
            trapFocus(submenu, closeButton);
          } catch (_) {}
        });
      }
    },
    true
  );
})();

  } catch(e) { console.error(e); }
})();
})();
